module.exports = __webpack_public_path__ + "img/B6.eec2f0c4.svg";